import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import HistoryOptions from './HistoryOptions';
import store from '../../../../store';

function HistoryOptionsContainer({ item }) {
  const onDelete = useCallback(() => {
    store.dispatch.history.delete(item.index);
  }, [item]);
  return <HistoryOptions onDelete={onDelete} />;
}

HistoryOptionsContainer.propTypes = {
  item: PropTypes.object.isRequired,
};

export default HistoryOptionsContainer;
